export function getNestedValue<T>(
  obj: Record<string, any>,
  keyPath: string
): T {
  return keyPath
    .split('.')
    .reduce(
      (acc, key) => (acc && acc[key] !== undefined ? acc[key] : ''),
      obj
    ) as T;
}
